import axios from "../axios/index.js";

const urlGetSocialList = "/api/social/get-list";
const urlCreateSocial = "/api/social/create";
const urlUpdateSocial = "/api/social/update/";
const urlGetSocialDetail = "/api/social/detail/";
const urlDeleteProduct = "/api/social/delete/";
const urlGetListWithoutPaginate = "/api/social/getListWithoutPaginate"

export default {
    getList(params) {
        return axios.get(urlGetSocialList, { 
            params: params
        });
    },

    getListWithoutPaginate() {
        return axios.get(urlGetListWithoutPaginate);
    },

    getDetail(id) {
        return axios.get(urlGetSocialDetail + id);
    },

    create(params, config) {
        return axios.post(urlCreateSocial, params, config);
    },

    update(params, id) {
        return axios.post(urlUpdateSocial + id, params);
    },

    delete(id) {
        return axios.post(urlDeleteProduct + id, id);
    },
};
